import { useEffect, useMemo, useRef } from 'react';
import { useFieldHelper, LinkFieldProps, LinkField } from 'framework/ui/field';
import { getAnchor, scrollToHash } from 'framework/utils';
import { useLocation } from 'react-router-dom';
import { useNewProjectUrl } from 'domain/shared/newProject';

const PreviewAnchorLinkField = ({
  projectId,
  idSource,
  ...props
}: LinkFieldProps & {
  projectId: string;
  idSource: string;
}) => {
  const { getValue: getAlias } = useFieldHelper(props);
  const { getValue: getId } = useFieldHelper({ source: idSource });
  const anchor = useMemo(() => getAnchor(getAlias()), [getAlias]);
  const anchorRef = useRef<HTMLAnchorElement>(null);
  const { hash } = useLocation();
  const { getPreviewChangeRequestUrl } = useNewProjectUrl();

  useEffect(() => {
    if (hash && anchorRef.current && anchorRef.current.getAttribute('href') === hash) {
      scrollToHash(anchorRef.current);
    }
  }, [hash]);

  return (
    <a href={`#${anchor}`} id={`copy-${anchor}`} ref={anchorRef} className="invisible-anchor">
      <LinkField linkText={getAlias()} isInternal value={getPreviewChangeRequestUrl(projectId, getId())} />
    </a>
  );
};
export default PreviewAnchorLinkField;
